<template>
  <div class="login">
    <div class="header">
      <img src="../assets/header.svg" alt="">
    </div>
    <div class="main">
      <div class="main-conter">
        <div class="main-conter-left">
          <p class="text-top">“</p>
          <p class="text-left">只要生命还可珍贵，</p>
          <p class="text-right">医生这个职业就永远倍受崇拜”</p>
          <p class="text-right">-------爱默生</p>
        </div>
        <div class="main-conter-right" ref="loginDiv"></div>
      </div>
    </div>
    <div class="footer" id="footer">
      <div class="copyright_info">
        <p>
          <a href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000088" target="_blank">京公网安备 11000002000088号</a>
          <span class="copyright_split">|</span>
          <span>京ICP证070359号</span>
          <span class="copyright_split">|</span>
          <a href="//img30.360buyimg.com/poprx/jfs/t1/45702/1/7206/3652062/5d4d3f4fE7ea82da4/207332da28ae8230.png" target="_blank">互联网药品信息服务资格证编号(京)-经营性-2014-0008</a>
          <span class="copyright_split">|</span>
          <span>新出发京零&nbsp;字第大120007号</span></p>
        <p><span>互联网出版许可证编号新出网证(京)字150号</span>
          <span class="copyright_split">|</span>
          <a href="//pro.jd.com/mall/active/3bVDLXHdwVmdQksGF8TtS7ocq1NY/index.html" target="_blank">出版物经营许可证</a>
          <span class="copyright_split">|</span>
          <a href="//misc.360buyimg.com/wz/wlwhjyxkz.jpg" target="_blank">网络文化经营许可证京网文[2014]2148-348号</a>
          <span class="copyright_split">|</span>
          <span>违法和不良信息举报电话：4006561155</span>
        </p>
        <p>
          <span class="copyright_text">Copyright&nbsp;©&nbsp;2004&nbsp;-&nbsp;
            <em id="copyright_year">2021</em>&nbsp;&nbsp;京东JD.com&nbsp;版权所有
          </span>
          <span class="copyright_split">|</span>
          <span>消费者维权热线：4006067733</span>
          <a href="//pro.jd.com/mall/active/38PitHBfR7ZopNHRSHnuuWR5AMDL/index.html" target="_blank" class="copyright_license">经营证照</a>
          <span class="copyright_split">|</span>
          <span>(京)网械平台备字(2018)第00003号</span>
          <span class="copyright_split">|</span>
          <a href="//storage.jd.com/imgtools/cbdaa22553-dccaf290-d1af-11e8-a840-89f99f5f0056.jpeg" target="_blank" class="mod_business_license">营业执照</a></p>
        <p class="mod_copyright_inter">
          <a class="mod_copyright_inter_lk" href="//www.joybuy.com/?source=1&amp;visitor_from=3" target="_blank" clstag="h|keycount|btm|btmnavi_null0501"><i class="mod_copyright_inter_ico mod_copyright_inter_ico_global"></i>
            Global Site</a>
          <span class="copyright_split">|</span>
          <a class="mod_copyright_inter_lk" href="//www.jd.ru/?source=1&amp;visitor_from=3" target="_blank" clstag="h|keycount|btm|btmnavi_null0502">
            <i class="mod_copyright_inter_ico mod_copyright_inter_ico_rissia"></i>
            Сайт России</a>
          <span class="copyright_split">|</span>
          <a class="mod_copyright_inter_lk" href="//www.jd.id/?source=1&amp;visitor_from=3" target="_blank" clstag="h|keycount|btm|btmnavi_null0503">
            <i class="mod_copyright_inter_ico mod_copyright_inter_ico_indonesia"></i>
            Situs Indonesia</a>
          <span class="copyright_split">|</span>
          <a class="mod_copyright_inter_lk" href="//www.joybuy.es/?source=1&amp;visitor_from=3" target="_blank" clstag="h|keycount|btm|btmnavi_null0504">
            <i class="mod_copyright_inter_ico mod_copyright_inter_ico_spain"></i>
            Sitio de España</a><span class="copyright_split">|</span>
          <a class="mod_copyright_inter_lk" href="//www.jd.co.th/?source=1&amp;visitor_from=3" target="_blank" clstag="h|keycount|btm|btmnavi_null0505">
            <i class="mod_copyright_inter_ico mod_copyright_inter_ico_thailand"></i>
            เว็บไซต์ประเทศไทย</a></p>
        <p><span>京东旗下网站：</span>
          <a href="https://www.jdpay.com/" target="_blank">京东钱包</a>
          <span class="copyright_split">|</span>
          <a href="https://www.jdcloud.com" target="_blank">京东智联云</a>
        </p>
      </div>
      <p class="copyright_auth">
        <a id="urlknet" class="copyright_auth_ico copyright_auth_ico_2" onclick="CNNIC_change('urlknet')" oncontextmenu="return false;" name="CNNIC_seal" href="https://ss.knet.cn/verifyseal.dll?sn=2008070300100000031&amp;ct=df&amp;pa=700817" target="_blank">可信网站信用评估</a>
        <a class="copyright_auth_ico copyright_auth_ico_3" href="http://www.cyberpolice.cn/" target="_blank">网络警察提醒你</a>
        <a class="copyright_auth_ico copyright_auth_ico_4" href="https://search.szfw.org/cert/l/CX20120111001803001836" target="_blank">诚信网站</a>
        <a class="copyright_auth_ico copyright_auth_ico_5" href="http://www.12377.cn" target="_blank">中国互联网举报中心</a>
        <a class="copyright_auth_ico copyright_auth_ico_6" href="http://www.12377.cn/node_548446.htm" target="_blank">网络举报APP下载</a>
      </p>
    </div>
  </div>
</template>
<script>
import utils from "@/utils";
export default {
  name: "logo",
  data() {
    return {
    	APP_TYPE: process.env.VUE_APP_TYPE,
    }
  },
  mounted(){
    this.initLogin();
    $('#div_logoutLoading').remove();
    var _this = this;
    this.resetMainHeight();
    $(window).bind('resize', function(){
      _this.resetMainHeight();
    });
  },
  methods: {
    initLogin() {
      const options = Object.assign({}, utils.loginOptions);
      if (process.env.VUE_APP_TYPE == 'admin') {
        options.onlyOneLoginType = 'ERP';
        options.loginType = 'ERP';
        options.protocol = 'http';
      } else if (process.env.VUE_APP_TYPE == 'man') {
        // man端可能erp 或者 jdpin 登录，具体跳转到哪个登录待定 TODO
        var logintype = window.sessionStorage.getItem('logintype');
        if (logintype) {
          options.loginType = logintype.toUpperCase();
        } else {
          options.loginType = 'ERP';
        }
      } else {
        options.onlyOneLoginType = 'JDPIN';
        options.loginType = 'JDPIN';
      }
      window.jdLoginTools_create_by_team_aris.initLoginForm(this.$refs.loginDiv, options);
    },
    resetMainHeight(){
      var height = $(window).height() - $('.header').outerHeight() - $('.footer').outerHeight() - 1;
      $('.main').css('height', (height < 600 ? 600 : height)+'px');
    },
  },
}

</script>
<style lang="scss" scoped>

.login {
  width: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  width: 100%;
  height: 120px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 6px 0px rgba(61, 106, 209, 0.05);

  img {
    width: 399px;
    height: 43px;
    margin-left: 10%;
    margin-top: 41px;
  }
}

.main {
  width: 100%;
  height: 545px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 6px 6px 0px rgba(61, 106, 209, 0.05);
  background-image: url('../assets/BigShoesChatting.png');
  background-repeat: no-repeat;
  background-size:cover;
  position: relative;

  .main-conter {
    //width: 1078px;
    height: 100%;
    margin: 0 auto;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .main-conter-left {
      width: 30%;
      height: 209px;
      margin-left: 10%;
      &>p {
        color: #fff;
        font-size: 24px;
        margin-top: 10px;
      }

      .text-top {
        margin-top: 0;
        font-size: 104px;
        height: 50px;
      }

      .text-left {
        text-align: left;
        margin-left: 50px;
      }

      .text-right {
        text-align: right;
      }
    }

    .main-conter-right {
      margin-right: 5%;
    }


  }

}




#footer {
	padding-top: 20px;
  padding-bottom: 30px;
  background: #eaeaea;
  text-align: center;
}

#footer .copyright_links p {
  font-size: 0;
}

#footer .copyright_links p a,
#footer .copyright_links p span {
  font-size: 12px;
}

#footer .copyright_info {
  padding: 10px 0;
  line-height: 22px;
  color: #999;
}

#footer .copyright_info a {
  color: #999;
}

#footer .copyright_info a:hover {
  color: #f30213;
}

#footer .copyright_split {
  margin: 0 6px;
  color: #ccc;
}

#footer .copyright_license {
  margin-left: 16px;
}

#footer .copyright_auth_ico {
  overflow: hidden;
  display: inline-block;
  margin: 0 3px;
  width: 103px;
  height: 32px;
  background-image: url('https://misc.360buyimg.com/jdf/1.0.0/unit/global-footer/5.0.0/i/new_footer.png');
  line-height: 1000px;
}

#footer .copyright_auth_ico_1 {
  background-position: 0 0;
}

#footer .copyright_auth_ico_2 {
  background-position: -104px 0;
}

#footer .copyright_auth_ico_3 {
  background-position: 0 -33px;
}

#footer .copyright_auth_ico_4 {
  background-position: -104px -33px;
}

#footer .copyright_auth_ico_5 {
  background-position: 0 -66px;
}

#footer .copyright_auth_ico_6 {
  background-position: -104px -66px;
}

#footer .mod_copyright_inter_ico {
  display: inline-block;
  width: 15px;
  height: 10px;
  vertical-align: -1px;
  margin-right: 10px;
  background-repeat: no-repeat;
  background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADcAAAAbCAYAAADYtRcLAAAAAklEQVR4AewaftIAAALFSURBVO3BTYhVVQAA4O9cn454xr+F0dA1FbOwQDBOgkFQizYtslzUokhCyBZCUWRBm9JVWSujRSW1iRDBCMKiaNMiqQ5URIU/pOgNRaJMHME3+m7PrpHKTMHj8Rim+b5Q17W/VSkNYzMewM04hD04jp1lzm2XCSG4Wt2lR6HLVb4Yvr7Wo5ZLqpRuxF4s949RvICleLVKaXuZ81EDNHpmlssFjdp/a+mqUhrGXix3pTfLnDv4uUrpKWyvUnq2zPmcAblp068EdAhFbe41HQGnTxbqTqBAbVwtjc1Y7kp7MaNKaWmZ85Ey57Eqpc/xGHaYQLj9Pf20+MVT/hIQOfTlDGd/v2DVXagxhmBcLY37cARLEDTuwUK8oatKaQ7ewgHsMCgHNeYFh3+Mdm9dZOTO+81fsMeSeIQLqI2r0PiozHkZTmhsw+P4tMy51ngfC7DSoBXoDPltf3L83Byj7aX++OkO9YUZFCbU0ggaBzGC3WXO31cpjeiqUgpYg4CZ/sUPp5/Tq1uMYwUKdM6J60+497pTOoe3mHnrYmFlzRhq42pptDTW4SV8XKX0LR7VVeZcVyk9iA/xlQE6tnW+i2rMLo5aNW+YMOzsrsrRsblCMKGWxi9VSivKnA9iU5XSK3ga31UpPVzm/FmZ8ydVShsx0wDtf32RRq2lRkdjnvMCgokUGjvxZJXSLI1dGMW1eERXldIcrME7BijGthjbYhwzFM8bih1DsWMonhfjmBjbYmyLsS3GthjbYmyLsS3Ude2iKqUSW/BamfOBKqUNeBvLsBAbsa3M+aRLQggms8IlZc4VnsHdVUovYwPO4HmsxhNlzidNmzZt2v9RqKn1KBBc5d2R1bUePXT8m6CPWvps3aF9ehZn66fCFNbSZ2tvW2+yKExhLXWtZyGYzFr6bN/Xe/RqOM7WT4UprKXPPrhhrcmiMIX9CRYv4u0MBGIsAAAAAElFTkSuQmCC);
}

#footer .mod_copyright_inter_ico_global {
  background-position: 0 0;
  width: 15px;
  height: 12px;
  margin-top: -1px;
}

#footer .mod_copyright_inter_ico_rissia {
  background-position: -20px 0;
}

#footer .mod_copyright_inter_ico_indonesia {
  background-position: 0 -17px;
}

#footer .mod_copyright_inter_ico_thailand {
  background-position: -20px -17px;
}

#footer .mod_copyright_inter_ico_spain {
  background-position: -40px 0;
}

.w1190 #footer .copyright_split,
.w1200 #footer .copyright_split {
  margin: 0 10px;
}


</style>
